import BatchBaseController from '../common/batch.base.controller'

class BatchEditController extends BatchBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, BatchService, Modal, $translate, $stateParams, LocationService, $q) {

		super(Auth, $state, User, BatchService, Modal, $translate, $stateParams)

		this.LocationService = LocationService
		this.$q = $q;

		this.defaultModel = {
			inputType: '',
			description: '',
			locationId: '',
			batchSourceId: ''
		}

		this.inputTypes = [
			'UUU',
			'UVV',
			'VVV',
			'ULV',
			'UHV',
			'VUV'
		]
		this.DEFAULT_INPUT_TYPE = 'VVV';
		this.locations = [];
		this.batchName = $stateParams.id;
		this.currentBranch = User.getUser().branchId;
		this.model = angular.copy(this.defaultModel)
	}

	$onInit() {
		this.$q.all([
			this.Service.get(this.$stateParams.id),
			this.LocationService.get(this.$stateParams.id)
		])
			.then((data) => {
				const batchData = data[0];
				const locationData = data[1];

				this.rawId = batchData.batchSourceId
				// this.model.id = data.id
				// this.model.description = data.description
				// this.model.inputType = data.inputType
				// this.model.batchSourceId = data.batchSourceId
				for (let key in this.model) {
					this.defaultModel[key] = batchData[key];
				}

				this.batchName = this.rawId + ' | ' + locationData.name;
				this.model = angular.copy(this.defaultModel)
			})
	}

	reset() {
		// this.$q.all([
		// 	this.Service.get(this.$stateParams.id),
		// 	this.LocationService.get(this.$stateParams.id)
		// ])
		// 	.then((data) => {
		// 		const batchData = data[0];
		// 		const locationData = data[1];
		// 		this.rawId = batchData.batchSourceId
		// 		for (let key in this.model) {
		// 			this.model[key] = batchData[key];
		// 		}
		// 		this.batchName = this.rawId + ' | ' + locationData.name;
		// 	})
		this.model = angular.copy(this.defaultModel)
	}

	submit(evt) {
		// if (!this.validate()) {
		// 	return
		// }

		this.loading = true
		this.Service.update(this.rawId, {
			id: this.model.id,
			description: this.model.description,
			inputType: this.model.inputType,
			batchSourceId: this.model.batchSourceId
		},  this.currentBranch)
			.then((data) => {
				this.loading = false
				window.history.go(-1)
			})
			.catch((err) => {
				this.loading = false
				err.data.errors.map((e) => {
					this.errorMessage += e.message + '<br/>'
				})
			})
	}
}

export default BatchEditController;


// WEBPACK FOOTER //
// ./client/app/components/batch/edit/batch.edit.controller.js